<div class="Thumbnails Flexbox Flexbox--column Align--center Gap--tiny">
  @for (thumbnail of tinyThumbnailURLs(); let i = $index; track thumbnail) {
    <button mat-button (click)="openGallery(images()[i])">
      <div class="ButtonContent Flexbox">
        <img [src]="thumbnail">
      </div>
    </button>
  }
</div>
